/**
 * canvas-engine/renderer/elements/NavElement.jsx
 *
 * OWN per-type element renderer for `nav` elements (header/footer chrome).
 *
 * ZERO REUSE: imports NOTHING from template-builder/ or academy-ui/src/template/.
 *
 * Inner-content vs positioning CONTRACT: renders ONLY the inner nav, filling its
 * positioned box. The parent CanvasRenderer owns positioning. DOM output is
 * identical in builder and reader modes. (Req 4.2, 17.1)
 *
 * Renders `content.items` (label/url) as nav links styled with
 * color/fontSize/fontWeight. Pure / presentational.
 */

import React from 'react';

function str(v) {
  return v == null ? '' : String(v);
}

function color(v, fallback) {
  return typeof v === 'string' && v.length > 0 ? v : fallback;
}

function num(v, fallback) {
  return Number.isFinite(v) ? v : fallback;
}

/**
 * Render a horizontal navigation list.
 *
 * @param {object} props
 * @param {object} props.element normalized `nav` Canvas_Element
 */
export default function NavElement({ element }) {
  const content = (element && element.content) || {};
  const style = (element && element.style) || {};

  const items = Array.isArray(content.items) ? content.items : [];

  const rootStyle = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: num(style.gap, 24),
    flexWrap: 'wrap',
    background: color(style.background, 'transparent'),
  };

  const linkStyle = {
    color: color(style.color, '#0f172a'),
    fontSize: num(style.fontSize, 16),
    fontWeight: num(style.fontWeight, 500),
    textDecoration: 'none',
  };

  return (
    <nav className="ce-nav" style={rootStyle}>
      {items.map((item, index) => {
        const it = item && typeof item === 'object' ? item : {};
        const label = str(it.label) || str(it.text);
        const url = str(it.url) || str(it.href);
        const key = str(it.id) || `nav-item-${index}`;
        return (
          <a key={key} className="ce-nav__link" href={url || undefined} style={linkStyle}>
            {label || 'Link'}
          </a>
        );
      })}
    </nav>
  );
}
